export default __webpack_public_path__ + "static/media/loading_tx.7eb99cf5.gif";